import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../api";
import { PageHeader, Table, Badge, Btn, eur, dt } from "../components/common";
import { toast } from "sonner";
import { useAutoRefresh } from "../lib/autoRefresh";

export default function Payments() {
  const [rows, setRows] = useState([]);
  const [dunning, setDunning] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/payments").then((r) => setRows(r.data)).catch(() => {});
    api.get("/dunning/state").then((r) => setDunning(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  useAutoRefresh(load);

  const runDunning = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/dunning/run");
      toast.success(`Dunning: ${data.lembretes} lembretes, ${data.suspensoes} suspensoes`);
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const cols = [
    { key: "organizacao_nome", label: "Cliente", render: (r) => <span className="font-semibold text-navy">{r.organizacao_nome}</span> },
    { key: "gateway_provider", label: "Gateway" },
    { key: "metodo", label: "Metodo" },
    { key: "valor", label: "Valor", render: (r) => eur(r.valor) },
    { key: "estado", label: "Estado", render: (r) => <Badge value={r.estado} /> },
    { key: "pago_em", label: "Pago em", render: (r) => dt(r.pago_em) },
  ];

  const dCols = [
    { key: "organizacao_nome", label: "Cliente", render: (r) => <span className="font-semibold text-navy">{r.organizacao_nome}</span> },
    { key: "moloni_document_id", label: "Fatura", render: (r) => <code className="text-xs">{r.moloni_document_id || "-"}</code> },
    { key: "total", label: "Valor", render: (r) => eur(r.total) },
    { key: "dias_atraso", label: "Dias atraso", render: (r) => <span className="font-semibold text-red-600">{r.dias_atraso}</span> },
    { key: "tentativas", label: "Lembretes", render: (r) => `${r.tentativas}/3` },
    { key: "dunning_estado", label: "Estado dunning", render: (r) => <Badge value={r.dunning_estado === "esgotado" ? "suspensa" : "em_atraso"} /> },
    { key: "proxima_em", label: "Proxima tentativa", render: (r) => r.proxima_em ? dt(r.proxima_em) : "-" },
  ];

  return (
    <div className="space-y-10">
      <div>
        <PageHeader overline="Conciliacao e dunning" title="Pagamentos" />
        <Table columns={cols} rows={rows} testid="payments-table" />
      </div>
      <div>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-navy font-bold text-lg">Faturas vencidas (dunning)</h2>
          <Btn onClick={runDunning} disabled={busy} testid="dunning-run">{busy ? "A executar..." : "Executar dunning"}</Btn>
        </div>
        <Table columns={dCols} rows={dunning} testid="dunning-table" />
      </div>
    </div>
  );
}
